import { render, staticRenderFns } from "./costdialoglists.vue?vue&type=template&id=506c9806&scoped=true"
import script from "./costdialoglists.vue?vue&type=script&lang=js"
export * from "./costdialoglists.vue?vue&type=script&lang=js"
import style0 from "./costdialoglists.vue?vue&type=style&index=0&id=506c9806&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "506c9806",
  null
  
)

export default component.exports